import { RoutePath } from "@app/constants";
import { Images } from "@assets/images";
import { useNavigate } from "react-router-dom";
import CampaignTable from "./components/campaign-table.page";
import NotificationTable from "./components/notification-table.page";
import BannerTable from "./components/banner-table.page";

const CampaignManagement = () => {
  const navigate = useNavigate();

  const handleCreateClick = () => {
    navigate(`/${RoutePath.CAMPAIGN_MANAGEMENT}/${RoutePath.CREATE_CAMPAIGN}`);
  };

  return (
    <div className="py-6 px-12">
      <div className="flex justify-between items-center">
        <div className="text-[#343C6A]">Danh sách campaign</div>
        <div>
          <button
            className="text-xl px-6 rounded-xl leading-14 h-14 bg-color-primary hover:bg-[#667ffc] text-white"
            onClick={handleCreateClick}
          >
            <div className="flex gap-4">
              <img src={Images.PlusIcon.default} alt="" />
              <div>Tạo mới</div>
            </div>
          </button>
        </div>
      </div>
      <CampaignTable />
      <NotificationTable />
      <BannerTable />
    </div>
  );
};

export default CampaignManagement;
